import { PageHeader } from '@/client/components/common/PageHeader';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/client/components/ui/card';
import { trpcVanilla } from '@/client/utils/trpc-client';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

export const Route = createFileRoute('/_app/analytics')({
  beforeLoad: async () => {
    const me = await trpcVanilla.user.me.query();
    if (me.role !== 'ADMIN') throw redirect({ to: '/' });
  },
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Analytics"
        eyebrow="Insights"
        description="Track your key metrics."
        icon={BarChart3}
      />

      <Card>
        <CardHeader>
          <CardTitle>Overview</CardTitle>
          <CardDescription>Connect your analytics provider to display charts.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Analytics coming soon.</p>
        </CardContent>
      </Card>
    </div>
  );
}
